import { useState } from "react";
import { signOut } from "firebase/auth";
import { LoaderCircle } from "lucide-react";
import { Wordmark } from "@cop/ui";
import { auth } from "../lib/firebase";
import { signInWithGoogle, useSession } from "../lib/session";

export function Login() {
  const { user, isStaff, authError } = useSession();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const shown = error ?? authError;

  return (
    <div className="login">
      <div className="login-card">
        <Wordmark className="login-brand" />
        <h1>Ingresar al panel del consultorio</h1>
        {user && !isStaff ? (
          <div className="notice notice-warn" role="alert">
            <p>
              La cuenta <strong>{user.email}</strong> no tiene un rol del equipo asignado. Pedile a Dirección que te habilite.
            </p>
            <button className="btn" onClick={() => signOut(auth)}>
              Usar otra cuenta
            </button>
          </div>
        ) : (
          <div className="stack">
            <button
              type="button"
              className="btn btn-primary"
              disabled={busy}
              aria-busy={busy}
              onClick={async () => {
                setBusy(true);
                try {
                  await signInWithGoogle();
                } catch {
                  setError("No pudimos ingresar con Google.");
                  setBusy(false);
                }
              }}
            >
              {busy && <LoaderCircle className="spin" size={16} aria-hidden />} Continuar con Google
            </button>
            {shown && (
              <p className="field-error" role="alert">
                {shown}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
